import React from "react";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import useIbenda from "../../hooks/useIbenda";
import IbendaComponent from "./IbendaComponent";

const TermsAndConditions = () => {
  const { isLoading } = useIbenda();

  return (
    <div>
      <Header />
      <div className="tf-connect-wallet tf-section">
        {!isLoading && (
          <IbendaComponent
            title={"Terms and Conditions"}
            id={"terms-and-conditions/87038604"}
          />
        )}
      </div>
      <Footer />
    </div>
  );
};

export default TermsAndConditions;
